module.exports = __webpack_public_path__ + "img/zec.a5ebf92c.svg";